import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';
// import 'jspdf-autotable';
import * as moment from 'moment';

//declare let jsPDF: any;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export class FileDownloadService {
  constructor() { }

  static exportAsExcelFile(json, excelFileName) {
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  static saveAsExcelFile(buffer, fileName) {
    const data = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  static downloadAsPdf(columns, rows, fileName, columnStyles) {
    const doc = new jsPDF('p', 'pt');
    doc.autoTable(columns, rows, {
      styles: {
        overflow: 'linebreak',
        cellWidth: 'wrap',
      },
      columnStyles: columnStyles
    });
    doc.save(fileName);
  }

  static prepExcelDownload(itemList, selectedItems, fileName) {
    //console.log('this.state.filteredCamEvents',itemList,selectedItems )

    const camEvents = [];
    let index = 1;

    for(const item of itemList) {
      const e = {};

      e['No.'] = index;
      for(const sItem of selectedItems) {
        if(sItem === 'event_time') {
          e[sItem] = moment(item[sItem]).format('YYYY-DD-MM HH:mm:ss:SSS');
        } else {
          e[sItem] = item[sItem];
        }
      }

      camEvents.push(e);

      index++;
    }

    this.exportAsExcelFile(camEvents, fileName);
  }

  static prepPdfDownload(itemList, selectedItems , fileName, columnStyles) {
    const columns = [];

    columns.push({title: 'No.'});
    for(const sItem of selectedItems) {
      columns.push({title: sItem});
    }

    const rows = [];
    let tempRow = [];
    let index = 1;

    for(const item of itemList) {

      tempRow = [index];

      for(const sItem of selectedItems) {
        tempRow.push(item[sItem]);
      }

      rows.push(tempRow);
      index++;
    }

    this.downloadAsPdf(columns, rows, fileName, columnStyles);
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/FileDownloadService.js